import { Select } from "antd";
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { fetchCarHouses, fetchLocations } from "$api/client";

const SelectLocation = ({ selectedItem, handleChange }) => {
  const { data: locationArr } = useSuspenseQuery({
    queryKey: ["locations"],
    queryFn: fetchLocations,
  });

  const { data: carHousesArr } = useQuery({
    queryKey: ["carHouses", locationArr],
    queryFn: fetchCarHouses,
    enabled: !!locationArr,
  });

  const handleSelect = (value, option) => {
    handleChange({
      locationId: value,
      dealerCode: option.dealerCode,
      deliveryTime: option.deliveryTime,
    });
  };

  const groups = carHousesArr
    ?.map((value) => {
      let currItem = {
        label: <span>{value.name}</span>,
        car_house_id: value.id,
        title: `${value.name}`,
        options: [],
      };

      locationArr.forEach((location, index) => {
        if (location.car_house_id === value.id) {
          currItem.options.push({
            value: location.id,
            dealerCode: location.crm_dealercode,
            deliveryTime: location.delivery_time,
            label: <span>{location.address}</span>,
          });
        }
      });
      if (currItem.options.length !== 0) {
        return currItem;
      }
      return {};
    })
    .filter((value) => Object.keys(value).length > 0);

  if (groups && groups.length > 0) {
    return (
      <Select
        key={selectedItem}
        defaultValue={selectedItem}
        style={{
          width: 200,
        }}
        onChange={handleSelect}
        options={groups}
        size="large"
      />
    );
  }
  return null;
};

export default SelectLocation;
